import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

function resetScroll() {
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  window.scrollTo(0, 0);
}

/**
 * SPA pages share one document scroll position — reset on pathname change
 * so each navigation starts at the top (desktop + mobile).
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // Disable browser restoring prior scroll on SPA navigations.
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    resetScroll();
    // Catch late focus / browser restore after paint.
    const raf = requestAnimationFrame(resetScroll);
    const t = window.setTimeout(resetScroll, 0);
    return () => {
      cancelAnimationFrame(raf);
      window.clearTimeout(t);
    };
  }, [pathname]);

  return null;
}
